import ResponsiveArt from "@/components/ResponsiveArt";

/**
 * Drop-in <img> replacement — now backed by <picture> with AVIF + WebP +
 * responsive widths and explicit width/height (kills CLS). API is
 * unchanged: existing callers continue to work.
 *
 * Props:
 *  - src       : main image url
 *  - alt       : alt text (required for a11y)
 *  - className : passed to the inner <img>
 *  - eager     : if true → loading="eager" + decoding="sync" + fetchpriority="high"
 *  - bg        : placeholder colour (default warm bone tone)
 *  - sizes     : sizes attribute (recommended)
 *  - testid    : data-testid passthrough
 */
export default function OptImg({ src, alt, className = "", eager = false, bg = "#E8E6DD", sizes, testid, ...rest }) {
  return (
    <ResponsiveArt
      src={src}
      alt={alt}
      sizes={sizes}
      eager={eager}
      className={className}
      bg={bg}
      testid={testid}
      {...rest}
    />
  );
}
